import Script from "next/script";
import { useEffect, useState } from "react";

export default function Zendesk() {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 45000);
  }, [])
  return (
    <>
      {isLoading ? null : <Script
        id="ze-snippet"
        strategy="afterInteractive"
        src="https://static.zdassets.com/ekr/snippet.js?key=ee2fba44-f982-496f-85fd-e0f0d48b4a5d"
        async
      />}
    </>
  );
}
